import React, { useEffect, useState } from 'react';
import { useParams, useNavigate} from 'react-router-dom';
import './PaymentSuccess.css';
import {fetchpaymentstatusforpaymentpopup} from '../../Global/Index';
import PaymentSuccess from './PaymentSuccess';

const PaymentAfterSOA = () => {
  
  const [paymentdatstatusresponse, setPaymentdatstatusresponse] = useState(false);
  const [transactiondetails, setTransactiondetails]=useState(null);


  const { transactionId } = useParams();
  const navigate=useNavigate();
   


  useEffect(() => {
    const fetchpaymentstatusdata = async () => {
      const resp = await fetchpaymentstatusforpaymentpopup(transactionId);
      console.log(`response of data in fetch payments status for soa is: ${JSON.stringify(resp)}`);
      if (resp.response.status === "200") {
        setTransactiondetails(resp.response.data[0]);
        if (resp.response.data.length > 0 && resp.response.data[0].flag == 0) {
          setPaymentdatstatusresponse(true);
        }else if(resp.response.data.length > 0 && resp.response.data[0].flag == 1){
          if(resp.response.data[0].type=="ASC"){
            navigate(`/success/Account-Statement`)
          }else{
            navigate(`/success/Pay-Online`)
          }
        }
        else if (resp.response.data.length == 0) {
        navigate(`/dashboard`);
        }
      } else if (resp.response.status === "419") {
        window.location.href = '/Session-Expired';
      } else if (resp.response.status === "500") {
        console.log('Something went wrong. Please try again later!');
      } else if (resp.response.status === "503") {
        console.log(resp.response.message);
      }else if(resp.response.status=='401'){
        window.location.href='/'
      }
    };

    fetchpaymentstatusdata();
  
   
  }, [transactionId]);



  return paymentdatstatusresponse && transactiondetails!=null ? (
    <div className="payment-success-container">
      <PaymentSuccess transactiondetails={transactiondetails} />
    </div>
  ) : null;

};

export default PaymentAfterSOA;
